/**
 * В новой ручке не будет необходимости в этих функциях, до перехода пока оставим
 * Переход на новую ручку будет в задаче CD-268682
 */
import { ERoomCountType, IDeveloperInfoFlatStats } from '../../../../types/developerInfo';
import { numberToPrettyString } from '../../../../utils/numberToPrettyString';

export const getRoomText = (roomType: ERoomCountType): string => {
  switch (roomType) {
    case ERoomCountType.Studio:
      return 'Студии';
    case ERoomCountType.OneRoom:
      return '1-комн.';
    case ERoomCountType.TwoRoom:
      return '2-комн.';
    case ERoomCountType.ThreeRoom:
      return '3-комн.';
    case ERoomCountType.FourRoom:
      return '4-комн.';
    case ERoomCountType.FiveRoom:
      return '5-комн.';
    case ERoomCountType.Large:
      return '6+ комн.';
    case ERoomCountType.OpenPlan:
      return 'Своб. план.';
    default:
      return '';
  }
};

export const getRoomLinks = (
  flatsStat: IDeveloperInfoFlatStats | null | undefined,
): Array<{ label: string; count: string; url: string }> => {
  const flats = flatsStat?.flats || [];
  const totalFlats = flatsStat?.total || 0;
  const allFlatsUrl = flatsStat?.url;

  const links: Array<{ label: string; count: string; url: string }> = [];

  if (totalFlats > 0 && allFlatsUrl) {
    links.push({
      label: 'Все',
      count: numberToPrettyString(totalFlats),
      url: allFlatsUrl,
    });
  }

  flats.forEach(flat => {
    if (!flat.roomCountType || !flat.count || !flat.url) {
      return;
    }

    const text = getRoomText(flat.roomCountType);
    if (!text) {
      return;
    }

    links.push({
      label: text,
      count: numberToPrettyString(flat.count),
      url: flat.url,
    });
  });

  return links;
};
